const supportsLocalStorage = (() => {
    try {
        const test = '__storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch {
        return false;
    }
})();

function setCookie(name, value, days) {
    let expires = '';
    if (days !== null) {
        expires = `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}`;
    }
    document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
}

function getCookie(name) {
    return document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1] ?? null;
}

function removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

const StorageWithExpiry = {
    /**
     * @param {string} key
     * @param {*} value
     * @param {number|null} ttlMs  null = never expires
     */
    set(key, value, ttlMs = null) {
        if (supportsLocalStorage) {
            const item = {
                value,
                expiry: ttlMs ? Date.now() + ttlMs : null,
            };
            localStorage.setItem(key, JSON.stringify(item));
        } else {
            const days = ttlMs ? Math.ceil(ttlMs / 864e5) : 365 * 20;
            setCookie(key, JSON.stringify(value), days);
        }
    },

    get(key) {
        if (supportsLocalStorage) {
            const raw = localStorage.getItem(key);
            if (!raw) return null;

            const item = JSON.parse(raw);

            if (item.expiry && Date.now() > item.expiry) {
                localStorage.removeItem(key);
                return null;
            }

            return item.value;
        }

        const cookie = getCookie(key);
        return cookie ? JSON.parse(cookie) : null;
    },

    remove(key) {
        if (supportsLocalStorage) {
            localStorage.removeItem(key);
        }
        removeCookie(key);
    },
};

export default StorageWithExpiry;
